(() => {
  const root = document.querySelector('[data-hz-catalog]');
  if (!root) return;
  const form = root.querySelector('[data-hz-filter-form]');
  const sidebar = root.querySelector('[data-hz-filters]');
  const backdrop = root.querySelector('.hz-catalog-filter-backdrop');
  const openButton = root.querySelector('[data-hz-open-filters]');
  const minInput = form.elements.namedItem('hz_min');
  const maxInput = form.elements.namedItem('hz_max');
  const stockInput = form.elements.namedItem('hz_stock');
  const styleInputs = Array.from(form.querySelectorAll('[name="hz_style"]'));
  const sortInput = root.querySelector('[data-hz-sort]');
  const productGrid = root.querySelector('[data-hz-product-grid]');
  const items = Array.from(root.querySelectorAll('[data-hz-product]'), (element) => ({
    element,
    styles: element.dataset.styles.split(','),
    price: Number(element.dataset.price) / 100,
    monthlySales: Number(element.dataset.monthlySales) || 0,
    available: element.dataset.inStock === 'true',
  }));
  // Shopify's new-store order history does not include the owner's imported sales.
  // Sort the complete rendered catalog before filtering and the 24-card display limit.
  if (sortInput.value === 'best-selling') {
    items.sort((a, b) => b.monthlySales - a.monthlySales || b.price - a.price);
    productGrid.append(...items.map((item) => item.element));
  }
  const mobile = window.matchMedia('(max-width: 760px)');
  const pageSize = 24;
  let shown = pageSize;
  let drawerOpen = false;
  let previousOverflow = '';
  let inputTimer;

  function closeFilters(restoreFocus = true) {
    if (!drawerOpen) return;
    drawerOpen = false;
    sidebar.classList.remove('is-open');
    sidebar.removeAttribute('role');
    sidebar.removeAttribute('aria-modal');
    backdrop.hidden = true;
    openButton.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = previousOverflow;
    if (restoreFocus && mobile.matches) openButton.focus();
  }

  openButton.addEventListener('click', () => {
    if (!mobile.matches) return;
    drawerOpen = true;
    previousOverflow = document.body.style.overflow;
    sidebar.classList.add('is-open');
    sidebar.setAttribute('role', 'dialog');
    sidebar.setAttribute('aria-modal', 'true');
    backdrop.hidden = false;
    openButton.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    sidebar.querySelector('[data-hz-close-filters]').focus();
  });
  root.querySelectorAll('[data-hz-close-filters]').forEach((button) => button.addEventListener('click', () => closeFilters()));
  mobile.addEventListener('change', () => closeFilters(false));
  document.addEventListener('keydown', (event) => {
    if (!drawerOpen) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      closeFilters();
    }
    if (event.key !== 'Tab') return;
    const focusable = Array.from(sidebar.querySelectorAll('button, input, summary, a[href]')).filter((element) => !element.disabled && element.getClientRects().length);
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && (document.activeElement === first || !sidebar.contains(document.activeElement))) {
      event.preventDefault();
      last?.focus();
    } else if (!event.shiftKey && (document.activeElement === last || !sidebar.contains(document.activeElement))) {
      event.preventDefault();
      first?.focus();
    }
  });

  function getState() {
    return {
      styles: styleInputs.filter((input) => input.checked).map((input) => input.value),
      minimum: minInput.value === '' ? 0 : Number(minInput.value),
      maximum: maxInput.value === '' ? Infinity : Number(maxInput.value),
      stock: stockInput.checked,
    };
  }

  function writeUrl(state) {
    const url = new URL(window.location.href);
    ['hz_style', 'hz_min', 'hz_max', 'hz_stock', 'page'].forEach((name) => url.searchParams.delete(name));
    state.styles.forEach((style) => url.searchParams.append('hz_style', style));
    if (minInput.value !== '') url.searchParams.set('hz_min', minInput.value);
    if (maxInput.value !== '') url.searchParams.set('hz_max', maxInput.value);
    if (state.stock) url.searchParams.set('hz_stock', '1');
    window.history.replaceState(null, '', url);
  }

  function readUrl() {
    const params = new URLSearchParams(window.location.search);
    styleInputs.forEach((input) => { input.checked = params.getAll('hz_style').includes(input.value); });
    [minInput, maxInput].forEach((input) => {
      const value = params.get(input.name);
      input.value = value !== null && value.trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0 ? value : '';
    });
    stockInput.checked = params.get('hz_stock') === '1';
  }

  function activeChip(text, remove) {
    const button = document.createElement('button');
    button.type = 'button';
    button.setAttribute('aria-label', `Remove filter: ${text}`);
    const label = document.createElement('span');
    label.textContent = text;
    const cross = document.createElement('span');
    cross.textContent = '×';
    cross.setAttribute('aria-hidden', 'true');
    button.append(label, cross);
    button.addEventListener('click', () => {
      remove();
      shown = pageSize;
      applyFilters(true);
    });
    return button;
  }

  function applyFilters(updateUrl = false) {
    const state = getState();
    const invalidPrice = !Number.isFinite(state.minimum) || state.minimum < 0 || Number.isNaN(state.maximum) || state.maximum < state.minimum;
    root.querySelector('[data-hz-price-error]').hidden = !invalidPrice;
    maxInput.setAttribute('aria-invalid', String(invalidPrice));
    if (invalidPrice) return false;

    const priceAndStock = (item) => item.price >= state.minimum && item.price <= state.maximum && (!state.stock || item.available);
    const matches = items.filter((item) => priceAndStock(item) && (!state.styles.length || state.styles.some((style) => item.styles.includes(style))));
    const visibleItems = new Set(matches.slice(0, shown));
    items.forEach((item) => { item.element.hidden = !visibleItems.has(item); });
    const count = matches.length;
    root.querySelector('[data-hz-result-count]').textContent = `${count} ${count === 1 ? 'product' : 'products'}`;
    root.querySelector('[data-hz-empty]').hidden = count !== 0;
    root.querySelector('[data-hz-more-wrap]').hidden = count === 0;
    root.querySelector('[data-hz-progress]').textContent = `Showing ${Math.min(shown, count)} of ${count} products`;
    root.querySelector('[data-hz-load-more]').hidden = shown >= count;
    root.querySelectorAll('[data-hz-style-count]').forEach((element) => {
      element.textContent = items.filter((item) => priceAndStock(item) && item.styles.includes(element.dataset.hzStyleCount)).length;
    });

    const active = root.querySelector('[data-hz-active-filters]');
    active.replaceChildren();
    styleInputs.filter((input) => input.checked).forEach((input) => {
      const label = input.parentElement.querySelector('span').textContent;
      active.append(activeChip(label, () => { input.checked = false; }));
    });
    if (minInput.value !== '' || maxInput.value !== '') {
      const priceLabel = maxInput.value === '' ? `Price: ${minInput.value || '0'}+` : `Price: ${minInput.value || '0'} – ${maxInput.value}`;
      active.append(activeChip(priceLabel, () => { minInput.value = ''; maxInput.value = ''; }));
    }
    if (state.stock) active.append(activeChip('In stock', () => { stockInput.checked = false; }));
    const filterCount = active.children.length;
    active.hidden = filterCount === 0;
    root.querySelector('[data-hz-filter-count]').textContent = filterCount ? `(${filterCount})` : '';
    if (updateUrl) writeUrl(state);
    return true;
  }

  form.addEventListener('change', () => {
    clearTimeout(inputTimer);
    shown = pageSize;
    applyFilters(true);
  });
  [minInput, maxInput].forEach((input) => input.addEventListener('input', () => {
    clearTimeout(inputTimer);
    inputTimer = window.setTimeout(() => { shown = pageSize; applyFilters(true); }, 250);
  }));
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    shown = pageSize;
    if (applyFilters(true)) closeFilters();
  });
  root.querySelectorAll('[data-hz-clear-filters]').forEach((button) => button.addEventListener('click', () => {
    clearTimeout(inputTimer);
    form.reset();
    shown = pageSize;
    applyFilters(true);
  }));
  root.querySelector('[data-hz-load-more]').addEventListener('click', () => {
    shown += pageSize;
    applyFilters();
  });
  root.querySelector('[data-hz-sort-form]').addEventListener('submit', (event) => {
    event.preventDefault();
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', root.querySelector('[data-hz-sort]').value);
    url.searchParams.delete('page');
    window.location.assign(url);
  });
  root.querySelector('[data-hz-sort]').addEventListener('change', () => root.querySelector('[data-hz-sort-form]').requestSubmit());
  window.addEventListener('popstate', () => { readUrl(); shown = pageSize; applyFilters(); });
  readUrl();
  applyFilters();
})();
